module.exports = __webpack_public_path__ + "img/ohyay_hosting.36722747.png";